export const pad = (num: number): string => {
  let s = String(num);
  if (s.length < 2) {
    s = '0' + s;
  }
  return s;
};
